"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _palette = _interopRequireDefault(require("../palette"));
var _palette$dashboard;
var _default = {
  contained: {
    padding: '6px 24px'
  },
  root: {},
  containedPrimary: {
    'color': _palette["default"].white,
    'backgroundColor': '#4a90e2',
    '&:hover': {
      backgroundColor: (_palette$dashboard = _palette["default"].dashboard) === null || _palette$dashboard === void 0 ? void 0 : _palette$dashboard.ocean
    }
  }
};
exports["default"] = _default;